import { FC, RefObject, PropsWithChildren, useEffect } from 'react';
import classNames from 'classnames';

type ComboboxProps = {
    rootRef: RefObject<HTMLElement | null>;
    isOpen: boolean;
    onOutsideClick: () => void;
};

export const Combobox: FC<PropsWithChildren<ComboboxProps>> = ({
    children,
    rootRef,
    isOpen,
    onOutsideClick,
}) => {
    useEffect(() => {
        const listenOutsideClick = async (event: MouseEvent) => {
            const target = event.target as Node;
            if (rootRef.current && !rootRef.current.contains(target)) {
                onOutsideClick();
            }
        };

        document.addEventListener('click', listenOutsideClick);
        return () => {
            document.removeEventListener('click', listenOutsideClick);
        };
    }, [rootRef, onOutsideClick]);

    return (
        <div className={classNames('position-relative w-100', { 'd-none': !isOpen })}>
            {children}
        </div>
    );
};
